const translations = {
  "en": {
    "© 2026 Ed: Wealth": "© 2026 Finture Development Limited (Ed:Wealth). All rights reserved.",
    "Privacy Policy": "Privacy Policy",
    "Sitemap": "Sitemap",
    "Terms of Use": "Terms of Use"
  },
  "zh-tw": {
    "© 2026 Ed: Wealth": "© 2026 Finture Development Limited (Ed:Wealth). All rights reserved.",
    "Privacy Policy": "隱私權政策",
    "Sitemap": "網站地圖",
    "Terms of Use": "使用條款"
  }
};

export default translations;
